import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";
import * as api from "core-module/services/api";

import config from "config.js";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import Button from "common/components/CustomButtons/Button.jsx";
// @material-ui/core components
import Grade from "@material-ui/icons/Grade";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;
const styles = {
  cardIconTitle: importedStyle.cardIconTitle,
  cardCategory: importedStyle.cardCategory,
  cardTitle: {
    ...importedStyle.cardTitle,
    margin: 30,
    marginTop: 30,
  },
  stats: importedStyle.stats,
  buttonBox: {
    display: "flex",
    alignSelf: "center",
  },
  buttonStyle: {
    margin: "20px",
  },
};
const ContactUS = (props) => {
  const { classes } = props;
  const userid = useSelector((state) => state.services.ids.user);
  const [uiValues, setUiValues] = useState({
    buttontext: null,
    description: null,
    redirecturl: null,
    text: "Offer not found",
    title: "Offer",
  });

  useEffect(() => {
    const offer = window.localStorage.getItem("of");
    if (offer) {
      api
        .post(`user.${userid}/offerquery`, {
          offercode: String(offer),
        })
        .then((res) => {
          if ("object" in res) {
            window.localStorage.setItem(
              "oldof",
              JSON.stringify({
                buttontext: res.object.buttontext,
                description: res.object.description,
                redirecturl: res.object.redirecturl,
                text: res.object.text,
                title: res.object.title,
              })
            );

            setUiValues({
              buttontext: res.object.buttontext,
              description: res.object.description,
              redirecturl: res.object.redirecturl,
              text: res.object.text,
              title: res.object.title,
            });

            if (
              "upgradetext" in res.object &&
              "expires" in res.object &&
              "offercode" in res.object
            ) {
              const upgradepromo = {
                expires: res.object.expires,
                upgradetext: res.object.upgradetext,
                offercode: res.object.offercode,
              };
              window.localStorage.setItem(
                `upgradepromo${userid}`,
                JSON.stringify(upgradepromo)
              );
            }
          }
          window.localStorage.removeItem("of");
        })
        .catch(() => {
          window.localStorage.removeItem("of");
        });
    } else {
      const oldoffer = window.localStorage.getItem("oldof");
      if (oldoffer) {
        setUiValues(JSON.parse(oldoffer));
      }
    }
  }, [userid]);

  function handleClickRedirect() {
    if (uiValues.redirecturl.charAt(0) === "/") {
      props.history.push(config.MYACCOUNT.APP_PATH + uiValues.redirecturl);
    } else {
      window.location.replace(uiValues.redirecturl);
    }
  }

  return (
    <div>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Grade />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{uiValues.title}</h4>
            </CardHeader>
            <CardBody className={classes.buttonBox}>
              <GridContainer align="center" justify="center">
                <GridItem xs={12}>
                  <h3 className={classes.cardTitle}>{uiValues.text}</h3>
                  <h5 className={classes.cardTitle}>{uiValues.description}</h5>
                  {uiValues.redirecturl != null ? (
                    <Button
                      className={classes.buttonStyle}
                      color="primary"
                      onClick={handleClickRedirect}
                    >
                      {uiValues.buttontext}
                    </Button>
                  ) : null}
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
};
export default withStyles(styles)(ContactUS);
